export default "__VITE_ASSET__BcnXPkMV__"